import { render, staticRenderFns } from "./AccountPerformanceForm.vue?vue&type=template&id=71070cf2&scoped=true"
import script from "./AccountPerformanceForm.vue?vue&type=script&lang=ts"
export * from "./AccountPerformanceForm.vue?vue&type=script&lang=ts"
import style0 from "./AccountPerformanceForm.vue?vue&type=style&index=0&id=71070cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71070cf2",
  null
  
)

export default component.exports